import type { SnapshotEntry } from '~/lib/api/types'
import { Row } from './row'
import styles from './column.module.scss'

type Props = {
  title: string
  entries: SnapshotEntry[]
  emptyText: string
  expandedSlackId: string | null
  onToggle: (slackId: string) => void
}

export function Column({
  title,
  entries,
  emptyText,
  expandedSlackId,
  onToggle,
}: Props) {
  return (
    <section className={styles.column} aria-label={title}>
      <header className={styles.head}>
        <h2 className={styles.title}>{title}</h2>
        <span className={`${styles.count} mono`}>{entries.length}</span>
      </header>
      <div className={styles.body}>
        {entries.length === 0 ? (
          <p className={styles.empty}>{emptyText}</p>
        ) : (
          entries.map(entry => (
            <Row
              key={entry.user.slack_user_id}
              entry={entry}
              expandedSlackId={expandedSlackId}
              onToggle={onToggle}
            />
          ))
        )}
      </div>
    </section>
  )
}
